import { render, staticRenderFns } from "./Land.vue?vue&type=template&id=7156d400"
import script from "./Land.vue?vue&type=script&lang=js"
export * from "./Land.vue?vue&type=script&lang=js"
import style0 from "./Land.vue?vue&type=style&index=0&id=7156d400&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports